import { entryFormChangePageSetEvent, entryFormChangePageEvent } from 'helpers/entries';
import { FormFieldPageLocationByName } from 'store/data/entries';
import { Form } from 'store/data/forms';

export function useEntryGoToChange(input: { setName?: string; form?: Form }) {
	const { setName } = input;

	function goToChange(params: {
		fieldNames: string[];
		formFieldPageLocationByName: FormFieldPageLocationByName;
		currentChangeLocal: number;
	}) {
		const { fieldNames, formFieldPageLocationByName, currentChangeLocal } = params;

		const firstFieldNameWithError = fieldNames[currentChangeLocal - 1];

		if (firstFieldNameWithError) {
			const isPaginated = firstFieldNameWithError in formFieldPageLocationByName;

			if (isPaginated) {
				const pageInfo = formFieldPageLocationByName[firstFieldNameWithError];

				const { pageIndex, group } = pageInfo;

				// SET PAGE WHERE 1ST ERROR FIELD IS
				const changePageEvent = setName
					? entryFormChangePageSetEvent
					: entryFormChangePageEvent;

				changePageEvent().dispatch({ pageIndex });

				// WAIT UNTIL PAGE WAS SET
				setTimeout(() => scrollToField(firstFieldNameWithError, group), 50);
			} else {
				// Debounce in JS call stack
				setTimeout(() => scrollToField(firstFieldNameWithError), 50);
			}
		}
	}

	function scrollToField(fieldName: string, group?: { groupName: string }) {
		const element = document.querySelector(`[id="${fieldName}"]`);

		if (element) return element.scrollIntoView({ block: 'center' });

		if (group) {
			const groupElement = document.querySelector(`[id="${group.groupName}"]`);

			if (groupElement) groupElement.scrollIntoView({ block: 'center' });
		}
	}

	return { goToChange };
}
